import { useEffect, useState } from "react";
import { motion, animate } from "framer-motion";
import { EASE } from "./Motion";

export default function Preloader({ onDone }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const controls = animate(0, 100, {
      duration: 1.8,
      ease: [0.65, 0, 0.35, 1],
      onUpdate: (v) => setCount(Math.round(v)),
      onComplete: () => setTimeout(onDone, 350),
    });
    return () => controls.stop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <motion.div
      exit={{ y: "-100%" }}
      transition={{ duration: 1, ease: EASE }}
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-ink"
      data-testid="preloader"
    >
      <div className="flex items-end overflow-hidden">
        {"BEATKINGSMM".split("").map((c, i) => (
          <span key={i} className="inline-block overflow-hidden">
            <motion.span
              className="inline-block font-serif text-3xl font-semibold tracking-[0.18em] text-neutral-100 sm:text-5xl"
              initial={{ y: "110%" }}
              animate={{ y: "0%" }}
              transition={{ duration: 0.9, ease: EASE, delay: 0.15 + i * 0.045 }}
            >
              {c}
            </motion.span>
          </span>
        ))}
        <motion.span
          className="mb-1 ml-3 font-mono text-lg text-gold sm:text-2xl"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: EASE, delay: 0.95 }}
        >
          2.0
        </motion.span>
      </div>

      <div className="mt-10 h-px w-56 overflow-hidden bg-white/10">
        <motion.div
          className="h-full origin-left bg-gradient-to-r from-goldlight to-gold"
          style={{ scaleX: count / 100 }}
        />
      </div>

      <div className="absolute bottom-8 right-8 font-mono text-xs tracking-[0.3em] text-neutral-500" data-testid="preloader-counter">
        {String(count).padStart(3, "0")} %
      </div>
      <div className="absolute bottom-8 left-8 font-mono text-[10px] tracking-[0.3em] text-gold/60">
        SINCE 2018
      </div>
    </motion.div>
  );
}
